<template>
  <div><PuilBrowser /></div>
</template>


<script setup>
import PuilBrowser from "@/components/puil/PuilBrowser.vue";
import { useAppStore } from "@/store/app-store";

const appStore = useAppStore();
appStore.drawerExpanded = true;
</script>
 
